import axios from '../plugins/axios'
import store from '../store'
const ls = require('local-storage')
let usuario = ls.get('nomeUsuario')

class ImpressaoUtilitario {
  getConfig () {
    // try {
    //   let dados = await axios.get('/relatorioCabecalho').then((res) => res.data);
    //   console.log(dados, ' A  impresasão');

    //   if (dados[0].descricaoCompleta && dados[0].logo) {
    //     return { logo: dados[0].logo, descricao: dados[0].descricaoCompleta  }
    //   } else {
    //     return { logo: 'users.png', descricao: 'Descrição não cadastrada no sistema' }
    //   }
    // } catch (error) {
    //   return { logo: 'users.png', descricao: 'Descrição não cadastrada no sistema' }
    // }

    if (window.location.host.includes('192.168.18.15')) {
      return { logo: 'ilhaverdade.jpg', descricao: 'Instituto Técnico Privado de Saúde-Ilha da Verdade' }
    } else if (window.location.host.includes('isppluena.com')) {
      return { logo: 'logo.jpeg', descricao: 'INSTITUTO SUPERIOR POLITÉCNICO PRIVADO DO LUENA' }
    } else if (window.location.host.includes('ispatlantida.com') || window.location.host.includes('192.168.44.10')) {
      return { logo: 'logoAt.jpeg', descricao: 'INSTITUTO SUPERIOR POLITÉCNICO ATLÂNTIDA' }
    } else if (window.location.host.includes('ispamazozo.com')) {
      return { logo: 'logoMazozo.jpeg', descricao: 'INSTITUTO SUPERIOR PRIVADO-ATLÂNTIDA-MAZOZO' }
    } else if (window.location.host.includes('bendizer.net')) {
      return { logo: 'logoB.jpeg', descricao: 'INSTITUTO MÉDIO TÉCNICO PRIVADO - BENDIZER' }
    } else if (window.location.host.includes('ilhaverdade')) {
      return { logo: 'ilhaverdade.jpg', descricao: 'INSTITUTO MÉDIO TÉCNICO PRIVADO - ILHA DA VERDADE' }
    } else {
      return { logo: 'logo.jpeg', descricao: 'INSTITUTO  SUPERIOR POLITÉCNICO PRIVADO DO LUENA' }
    }
  }
  datacorrente () {
    let d = new Date()
    let day = new Date()
    // @ts-ignore
    day = day.getDate()
    // @ts-ignore
    day = day.toString()
    let month = []
    month[0] = 'Janeiro'
    month[1] = 'Fevereiro'
    month[2] = 'Março'
    month[3] = 'Abril'
    month[4] = 'Maio'
    month[5] = 'Junho'
    month[6] = 'Julho'
    month[7] = 'Agosto'
    month[8] = 'Setembro'
    month[9] = 'Outubro'
    month[10] = 'Novembro'
    month[11] = 'Dezembro'
    return day.toString() + ' de ' + month[d.getMonth()] + ' de ' + (d.getFullYear()).toString()
  }
  // Método responsável por converter o HTML gerado pelo método gerarHTML() em um arquivo PDF
  async htmlToPDF (html, extraOptions, url, nameFile) {
    try {
      let result = await axios({
        method: 'post',
        url: `${url}writefile`,
        data: {
          html: html,
          file_name: nameFile,
          option: extraOptions
        }
      }).then(res => res.data)
      this.frame(url, nameFile)
    } catch (error) {
      store.state.isloading = false
    }
  }

  // Método responsável por criar a base HTML e renderizar o arquivo em outra aba
  frame (link, nameFile) {
    try {
      let url = link + 'readfile/' + nameFile + '.pdf'
      let frame = `
            <html>
                <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}</style>
                <body>
                <iframe target="_blank" type="application/pdf" src="${url}"></iframe>
                </body>
            </html>`
      let a = window.open('about:blank', '_blank', '')
      a.document.write(frame)
      a.document.close()
    } catch (error) {
      store.state.isloading = false
    } finally {
      store.state.isloading = false
    }
  }
  // Método responsável por criar a base DOCx e converte-la em PDF
  async docx (url, dados) {
    try {
      await axios({
        method: 'post',
        url: `${url}createReport`,
        data: dados
      }).then()
    } catch (error) {
      store.state.isloading = false
    } finally {
      store.state.isloading = false
    }
  }
}
export default new ImpressaoUtilitario()
